// sidebarBucketEmptyHints.js — empty-section education in the base sidebar

export const SIDEBAR_DATABASES_EMPTY_HINT =
  'Library is your inventory — projects, files, events, whatever you track. Create a collection, or just add something and we’ll make one for you.';

export const SIDEBAR_CHANNELS_EMPTY_HINT =
  'Channels are shared conversations in this base — announcements, project chats, or topic threads. Create one anytime.';
